<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.products')} / ${$t('menu.flights')}`"
      >
        <Flights></Flights>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import Flights from './tablas/FlightsList.vue'

export default {
  components: {
    AppCardCode,
    Flights,
  },
}
</script>
